import { Tooltip } from "primereact/tooltip";
import React from "react";
import { baseURL } from "../Api/ApiConstant";

interface SharedByAvatarProps {
    avatarKey?: number | number;
    profileImage?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    className?: string;
    showTooltip?: boolean;
}

const SharedByAvatar: React.FC<SharedByAvatarProps> = ({
    avatarKey,
    profileImage,
    firstName,
    lastName,
    className,
    showTooltip = true
}) => {
    return (
        <React.Fragment>
            <Tooltip target={`#tooltip_shared_by_contact_${avatarKey}`} />
            <div
                key={avatarKey}
                id={`tooltip_shared_by_contact_` + avatarKey}
                className={`task_contact_display m-auto ${className || ''}`}
                data-pr-tooltip={showTooltip ? (`Shared by: ${firstName + " " + lastName}`) : ''}
                data-pr-position="top"
            >
                {profileImage !== null ? (
                    <img
                        src={`${baseURL + profileImage}`}
                        alt=""
                    />
                ) : (
                    <span>
                        {firstName![0]}
                        {lastName![0]}
                    </span>
                )}
            </div>
        </React.Fragment>
    )
}

export default SharedByAvatar;